<template>
  <div id="password-setting" class="s-base">
    <v-card class="s-panel" max-width="1000">
      <v-card-title class="s-title">パスワード設定</v-card-title>
      <v-container>
        <v-row>
          <v-col align-self="center">
            <v-card
              class="py-3 px-5 mx-auto"
              color="primary"
              style="max-width: 80%"
            >
              <v-card-text>
                <v-form v-model="valid" @submit.prevent>
                  <v-text-field
                    v-model="nowpassword"
                    type="password"
                    label="現在のパスワードを入力"
                    required
                    class="px-3 white"
                    @keypress.enter="regist"
                    maxlength="255"
                  />
                  <v-text-field
                    v-model="nextpassword"
                    type="password"
                    label="新規パスワードを入力（12文字以上）"
                    required
                    class="px-3 mt-7 white"
                    @keypress.enter="regist"
                    maxlength="255"
                  />
                  <v-text-field
                    v-model="repassword"
                    type="password"
                    label="新規パスワードを再入力"
                    required
                    class="px-3 mt-3 white"
                    @keypress.enter="regist"
                    maxlength="255"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="regist"
                  :disabled="!valid"
                  color="secondary"
                  class="mx-auto"
                  height="40"
                  width="300px"
                >
                  登録
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" align-self="center">
            <div class="d-flex flex-row px-3">
              <v-btn color="primary" x-large @click="clickReturn()">戻る</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dispComplete" width="500" persistent>
      <v-card>
        <v-card-title class="s-title">パスワード設定</v-card-title>
        <v-container>
          <v-row class="pl-5">
            <v-col v-if="success">パスワードの設定が完了しました。</v-col>
            <v-col v-else>
              入力した情報に誤りがあります。<br />再度、パスワードをご確認ください。
            </v-col>
          </v-row>
          <v-btn
            @click="closeDispComplete()"
            color="primary"
            class="d-block mt-3 ml-auto"
            >閉じる</v-btn
          >
        </v-container>
      </v-card>
    </v-dialog>
    <request-error-dialog
      :requestErrorDialogFlag.sync="dialog.requestError"
      :httpStatus="httpStatus"
      :contractsInfoExists="contractsInfoExists"
      message=""
    />
  </div>
</template>

<script lang="ts">
import loginModule from "../store/LoginModule";
import { Component, Vue } from "vue-property-decorator";
import { userApi } from "@/api/UserApi";
import { NETWORK_ERROR } from "@/router";
import RequestErrorDialog from "./RequestErrorDialog.vue";
import Axios from "axios";

@Component({
  components: {
    "request-error-dialog": RequestErrorDialog,
  },
})
export default class PasswordSetting extends Vue {
  valid = false;

  nowpassword = "";
  nextpassword = "";
  repassword = "";
  dispComplete = false;
  success = false;

  dialog = {
    requestError: false,
  };

  httpStatus = 500;
  contractsInfoExists = true;

  clickReturn() {
    this.$router.push({ name: "Menu" });
  }

  closeDispComplete() {
    this.dispComplete = false;
    if (this.success === true) {
      this.$router.push({ name: "Menu" });
    }
  }

  async regist() {
    if (
      this.nextpassword === this.repassword &&
      this.nextpassword.length >= 12 &&
      this.nextpassword.length <= 255
    ) {
      try {
        const result = await userApi.setPassword(
          loginModule.userId,
          this.nowpassword,
          this.nextpassword
        );
        this.httpStatus = result.httpStatus;

        if (this.httpStatus === 200) {
          this.success = true;
          this.dispComplete = true;
        }
      } catch (error) {
        let newError: Error;
        if (Axios.isAxiosError(error) && error.response) {
          newError = new Error(error.response.status.toString());
        } else {
          newError = new Error(NETWORK_ERROR);
        }
        if (newError.message === "400") {
          // 400 Bad Request
          this.httpStatus = 400;
          this.success = false;
          this.dispComplete = true;
        } else if (newError.message === "401") {
          // 401 Unauthorized
          this.httpStatus = 401;
          this.dialog.requestError = true;
        } else if (newError.message === "404") {
          // 404 Not Found
          this.httpStatus = 404;
          this.contractsInfoExists = false;
          this.dialog.requestError = true;
        } else if (newError.message === "500") {
          // 500 Internal Server Error
          this.httpStatus = 500;
          this.dialog.requestError = true;
        } else {
          this.httpStatus = parseInt(newError.message);
          // 運用上起こってはいけないエラー
          await this.$router.push({ name: newError.message });
        }
      }
    } else {
      this.success = false;
      this.dispComplete = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
</style>
